import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { Category, InventoryManager, Item, MenuManager, OrderManager } from 'aigens-ng-core';
var ItemComponent = /** @class */ (function () {
    function ItemComponent(cdr, inventoryManager, menuManager) {
        this.cdr = cdr;
        this.inventoryManager = inventoryManager;
        this.menuManager = menuManager;
        this.removeClick = new EventEmitter();
        this.addClick = new EventEmitter();
        this.img = '';
        this.isSet = false;
        this.afterLastItemLoadJump = new EventEmitter();
    }
    Object.defineProperty(ItemComponent.prototype, "quantity", {
        set: function (quantity) {
            this._quantity = quantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ItemComponent.prototype, "item", {
        set: function (item) {
            this._item = item;
        },
        enumerable: true,
        configurable: true
    });
    ItemComponent.prototype.ngOnInit = function () {
        this.isParent = !!(this._item.variations && this._item.variations.length > 0);
        this.img = this._item.getImage('default', 150, true);
        this.isSet = Item.isSet(this.category, this._item);
        this.isModifiable = Item.isModifiable(this._item);
        this.isRequiredModifier = this.isModifiable && this._item.mgroups.some(function (mgroup) { return mgroup.min > 0; });
        this.name = this.getItemName();
        this.isSoldout = this.getSoldout();
    };
    ItemComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.last) { // 此时页面已经进入, 不影响首次进入page的性能
            setTimeout(function () {
                _this.afterLastItemLoadJump.emit();
                console.log(_this.last);
            }, 500);
        }
    };
    ItemComponent.prototype.getSoldout = function () {
        console.log('isSoldout');
        var result;
        var imSoldout = this.inventoryManager.isSoldout(this._item);
        result = (!this.isParent && imSoldout);
        var now = this.convertNowDateToStoreTimeZone(this.orderManager.store.timezone).getTime();
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this.category, this._item, this.orderManager.isTakeout(), now);
    };
    ItemComponent.prototype.convertNowDateToStoreTimeZone = function (timeZone) {
        timeZone = timeZone ? timeZone : 'GMT+8';
        var timeZoneValue = timeZone.split('GMT')[1];
        // let isPositive = timeZoneValue.startsWith('+');
        var integerTimeZoneValue = parseInt(timeZoneValue) * 60;
        var now = new Date();
        var timeZoneOffset = now.getTimezoneOffset();
        var newTime = now.getTime() + (timeZoneOffset + integerTimeZoneValue) * 60000;
        now.setTime(newTime);
        return now;
    };
    ItemComponent.prototype.getItemName = function () {
        var name = this._item.name;
        if (this.isParent) {
            name = this._item.title;
        }
        if (!name || name.length === 0) {
            name = this._item.name;
        }
        return name;
    };
    ItemComponent.prototype.removeClicked = function () {
        this.removeClick.emit();
    };
    ItemComponent.prototype.addClicked = function () {
        this.addClick.emit();
    };
    return ItemComponent;
}());
export { ItemComponent };
